export default __webpack_public_path__ + "static/media/logo-white.67bb7211.svg";